import { Router } from '@angular/router';

import { epicDependencies } from '../../../store';
import { createRouterQueryParams } from '../../builder-selection';

import { createParams } from './create-params.function';

export function updateRouterQueryParams(): void {
    const router = epicDependencies.injector.get<Router>(Router);

    const bp = createParams();
    const params = createRouterQueryParams(bp);

    void router.navigate(['report', 'builder'], {
        queryParams: params,
        replaceUrl: true,
    });
}
